export const structData = [
  [
    {
      value: 'Portfolio',
      border: 1,
      background: 2,
      bold: true,
      index: 0,
      eleProperty: [],
      textAlign: 'left'
    },
    {
      value: 'Total Cost',
      border: 0,
      background: 2,
      bold: true,
      index: 1,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Total Proceeds',
      border: 0,
      background: 2,
      bold: true,
      index: 2,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '退出部分MOIC',
      border: 0,
      background: 2,
      bold: true,
      index: 3,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Fully Diluted Ownership',
      border: 0,
      background: 2,
      bold: true,
      index: 4,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'class of Share',
      border: 0,
      background: 2,
      bold: true,
      index: 5,
      eleProperty: [],
      textAlign: 'center'
    },
    {
      value: 'Initial Investment Date',
      border: 0,
      background: 2,
      bold: true,
      index: 6,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Proceed Date',
      border: 0,
      background: 2,
      bold: true,
      index: 7,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Investment Cost',
      border: 0,
      background: 2,
      bold: true,
      index: 8,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Proceeds',
      border: 0,
      background: 2,
      bold: true,
      index: 9,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Cumulative Realized Appreciation(Depreciation)',
      border: 0,
      background: 2,
      bold: true,
      index: 10,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'MOIC',
      border: 0,
      background: 2,
      bold: true,
      index: 11,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'fully Diluted Ownership',
      border: 1,
      background: 2,
      bold: true,
      index: 12,
      eleProperty: [],
      textAlign: 'right'
    }
  ]
];
export const settings = {
  licenseKey: 'non-commercial-and-evaluation',
  data: [],
  rowHeaders: false,
  height: 120 + 17 * 30,
  width: '100%',
  hiddenColumns: {
    columns: [],
    indicators: true
  },
  renderAllRows: true, // 一次性渲染所有行
  viewportColumnRenderingOffset: 100, // 关闭虚拟列渲染,避免出现列高度不一致的问题
  nestedHeaders: [
    [
      { label: 'portfolio', colspan: 1.002 },
      { label: 'FMV信息', colspan: 12.002 }
    ],
    [
      { label: 'portfolio', colspan: 1.021 },
      { label: 'Total Cost', colspan: 1.021 },
      { label: 'Total Proceeds', colspan: 1.021 },
      { label: '退出部分MOIC', colspan: 1.021 },
      { label: 'Fully Diluted Ownership', colspan: 1.021 },
      { label: 'class of Share', colspan: 1.021 },
      { label: 'Initial Investment Date', colspan: 1.021 },
      { label: 'Proceed Date', colspan: 1.021 },
      { label: 'Investment Cost', colspan: 1.021 },
      { label: 'Proceeds', colspan: 1.021 },
      {
        label: 'Cumulative Realized Appreciation(Depreciation)',
        colspan: 1.021
      },
      { label: 'MOIC', colspan: 1.021 },
      { label: 'Fully Diluted Ownership', colspan: 1.021 }
    ]
  ],
  colWidths: Array(structData[0].length).fill(100),
  columns: Array(structData[0].length).fill({}),
  afterRenderer: (td, row, col, prop, value, cellProperties) => {
    renderStyle(td, row, col, prop, value, cellProperties);
    return td;
  }
};
export const columnMap = [
  'portFolio',
  'totalCost',
  'totalProceeds',
  'totalMOIC',
  'fullyDilutedOwnership',
  'classOfShare',
  'initialInvestmentDate',
  'proceedDate',
  'investmentCost',
  'proceeds',
  'cumulativeUnrealized',
  'MOIC',
  'fullyDilutedOwnership'
];
export const sumMap = {
  portFolio: 0,
  totalCost: 1,
  totalProceeds: 2,
  totalMOIC: 3,
  investmentCost: 8,
  proceedsSum: 9,
  cumulativeUnrealized: 10
};
export const projectMap = {
  portFolio: 0,
  totalCost: 1,
  totalProceeds: 2,
  exitMOIC: 3
};
export const fundMap = {
  classOfShare: 5,
  initialInvestmentDate: 6,
  proceedDate: 7,
  investmentCost: 8,
  proceeds: 9,
  cumulativeUnrealized: 10,
  MOIC: 11,
  fullyDilutedOwnership: [4, 12]
};
export const precisionMap = {
  zerobit: ['totalCost', 'totalProceeds', 'cumulativeUnrealized', 'investmentCost', 'proceeds'],
  twobit: ['totalMOIC', 'MOIC'],
  fourbit: ['fullyDilutedOwnership']
};
function renderStyle(td, row, col, prop, value, cellProperties) {
  // if (row == 0 && col == 0) {
  //   console.log("unrealized renderer", new Date().toISOString());
  // }
  const obj = Object.assign({}, structData[row + 1][col]);
  Object.assign(td.style, obj.style);
  td.innerHTML = obj.innerHTML;
  cellProperties.readOnly = obj.readOnly;
}
